import React, { useState, useEffect, useReducer, useRef } from "react";
import ScrollView from "devextreme-react/scroll-view";
import "../../styles/sps.css";
import Button from "devextreme-react/button";
import { FileUploader, TextArea } from "devextreme-react";
import DataGrid, {
  RequiredRule,
  Column,
  Editing,
  HeaderFilter,
  Paging,
  Pager,
  SearchPanel,
} from "devextreme-react/data-grid";
import WhiteBoard from "../common/WhiteBoard/WhiteBoard";
import AsyncCallHandler from "../../common/AsyncCallHandler";
import NEXUS_CONST from "../../common/constants";
import * as utils from "../../common/utils";
import sa3 from "../../reducers/sa3";
import * as actions from "../../actions/sa3";
import { confirm } from "devextreme/ui/dialog";
import { onDownloadFile } from "../../common/utils";
import notify from "devextreme/ui/notify";
import { alert } from "devextreme/ui/dialog";
import Fishbone from "../sps/Fishbone";
import WhyAnalyzer from "../sps/WhyAnalyzer";
import { Accordion, Item as AccordionItem } from "devextreme-react/accordion";
import { postUserLog } from "../../actions/common";
import { isSubPropertyUnique } from "./utils";
import {
  ALLOWED_FILE_EXTENSIONS,
  ALLOWED_MIME_TYPES,
} from "../../constants/allowedUploadTypes";
import { checkUploadFilesValid } from "../../utils/fileValidator";

const initialState = {};

const GapAnalysis = (props) => {
  const [WBRc, setWBRc] = useState(true);
  const [enableadd, setenableadd] = useState(true);
  const [GridData, setGridData] = useState([]);
  const [Comments, setComments] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [image, setImage] = useState(null);
  const [state, dispatch] = useReducer(sa3, initialState);
  const [whiteBrdData, setwhiteBrdData] = useState(
    JSON.stringify({ objects: [] })
  );
  const [fishBoneDes, setfishBoneDes] = useState("");
  const [topLevelWhys, setTopLevelWhys] = useState([]); // Array to add new branch
  const [whyDescription, setwhyDescription] = useState("");
  const [fishBoneData, setFishBoneData] = useState([{}]);
  const [selectedIndexes, setSelectedIndexes] = useState(0);
  const [isDisabled, setIsDisabled] = useState(true);

  let { gapAnalysisStateA3Data, attachmentsA3 } = state;
  const dataGridRef = useRef(null);
  let wbIs, wbRc;
  const wBRc = (k) => {
    wbRc = k;
  };
  const wBIs = (k) => {
    wbIs = k;
  };
  useEffect(() => {
    AsyncCallHandler(
      NEXUS_CONST.FETCH_A3_GAP_ANALYSIS_DATA + props.a3ID,
      NEXUS_CONST.GET
    ).then((res) => {
      AsyncCallHandler(
        NEXUS_CONST.FETCH_A3_DATA + props.a3ID,
        NEXUS_CONST.GET
      ).then((res) => {
        if (res) {
          setIsDisabled(res?.data?.status === "Complete");
          setfishBoneDes(res?.data?.fishboneDescription);
          setwhyDescription(
            res?.data?.whyProblemStatement !== null
              ? res?.data?.whyProblemStatement
              : ""
          );
        }
      });

      setGridData(res?.data?.gapAnalysisData);
      setComments(res?.data?.comments.comments);

      utils.set(
        "wbData_isa3",
        res?.data?.whiteBoard
          ? JSON.parse(res?.data?.whiteBoard)
          : { objects: [] }
      );
    });
    actions.GetAttachmentsDataA3(dispatch, props.a3ID, "GapAnalysis");
    AsyncCallHandler(
      `${NEXUS_CONST.FETCH_A3_FISHBONE}${props.a3ID}`,
      NEXUS_CONST.GET
    ).then((res) => {
      if (res) {
        setFishBoneData(res?.data?.fishbone);
      }
    });
    AsyncCallHandler(
      `${NEXUS_CONST.FETCH_A3_FIVEWHY}${props.a3ID}`,
      NEXUS_CONST.GET
    ).then((res) => {
      if (res) {
        setTopLevelWhys(res?.data);
      }
    });
  }, []);

  const initialstateConfig = {
    export: {
      enabled: true,
      fileName: "A3_GapAnalysis",
    },
  };

  const onInitNewRow = (e) => {
    let maxValue = GridData.reduce((max, obj) => {
      return obj.gapNumber > max ? obj.gapNumber : max;
    }, 0);
    e.data.gapNumber = maxValue + 1;
    e.data.a3ID = props.a3ID;
  };

  const onRowUpdated = () => {
    setenableadd(true);
  };
  const onRowInserted = () => {
    setenableadd(true);
  };
  const handlers = {
    onRowUpdated: onRowUpdated,
    onRowInserted: onRowInserted,
  };

  //files attachments handling
  const onFileSelect = (e) => {
    setSelectedFiles(e.value);

    if (e.value[0] !== undefined) {
      setImage(URL.createObjectURL(e.value[0]));
    }
  };

  const deleteFile = (id,attachmentName) => {
    let confirm_it = confirm(
      "Are you sure you want to delete?",
      "Confirm changes"
    );
    confirm_it.then((res) => {
      actions.deleteAttachmentA3(dispatch, id, props.a3ID, "GapAnalysis",attachmentName,props.TierId, props.activeTab);
    });
  };

  const handlTextBox = (e) => {
    setComments(e.value);
  };

  // const isSubPropertyUnique = (array, subProperty) => {
  //   const seen = new Set();

  //   let isUnique = true;
  //   array.forEach((obj) => {
  //     obj.subwhys.forEach((subObj) => {
  //       if (seen.has(subObj[subProperty])) {
  //         isUnique = false; // Subproperty is not unique
  //       }
  //       seen.add(subObj[subProperty]);
  //     });
  //   });

  //   return isUnique;
  // };

  //Validation
  const canGapAnalysisSave = () => {
    let updatedFishBone = fishBoneData?.map((obj) => {
      const filteredFish = obj?.lsCause?.filter((item) => item["value"] !== "");
      return { ...obj, lsCause: filteredFish };
    });
    const fishboneExist = updatedFishBone?.some((obj) => {
      return obj?.lsCause?.length > 0;
    });

    const updatedWhys = topLevelWhys.map((obj) => {
      const filteredSubwhys = obj?.subwhys?.filter(
        (item) => item["whyValue"] !== ""
      );
      return { ...obj, subwhys: filteredSubwhys };
    });
    const whysExists = updatedWhys.some((obj) => {
      return obj?.subwhys?.length > 0;
    });

    const gaComments =
      Comments == null || Comments == undefined || Comments.length == 0 ? 1 : 0;

    if (
      (fishboneExist || whysExists || gaComments) &&
      GridData &&
      GridData?.length > 0
    ) {
      return true;
    } else {
      return false;
    }
  };

  //save data
  const saveGapAnalysisData = () => {
    fishBoneData?.forEach((item, index) => {
      item?.lsCause?.forEach((item1, index) => {
        if (typeof item1.id === "string") {
          item1.id = 0;
        }
      });
    });

    if (!canGapAnalysisSave()) {
      setIsDisabled(false);
      alert(
        "Please enter at least one record in cause table and fill 5 Why/Fishbone/Comments to save",
        "Alert"
      );
      return false;
    } else {
      let updatedWhys = topLevelWhys.map((obj) => {
        const filteredSubwhys = obj?.subwhys?.filter(
          (item) => item["whyValue"] !== ""
        );
        return { ...obj, subwhys: filteredSubwhys };
      });

      const whysExists = updatedWhys.some((obj) => {
        return obj?.subwhys?.length > 0;
      });

      let updatedFishBone = fishBoneData?.map((obj) => {
        const filteredFish = obj?.lsCause?.filter(
          (item) => item["value"] !== ""
        );
        return { ...obj, lsCause: filteredFish };
      });
      const fishBoneExist = updatedFishBone?.some((obj) => {
        return obj?.lsCause?.length > 0;
      });

      if (
        whysExists &&
        (!isSubPropertyUnique(updatedWhys, "whyValue") || whyDescription === "")
      ) {
        setIsDisabled(false);
        alert(
          "Please make sure all why's added are unique and Problem statement field is not empty",
          "Alert"
        );
        return false;
      }

      if (
        fishBoneExist &&
        (fishBoneDes === undefined ||
          fishBoneDes === null ||
          fishBoneDes === "")
      ) {
        setIsDisabled(false);
        alert("Please Fill Fisbone Description", "Alert");
        return false;
      }
      topLevelWhys?.forEach((item, index) => {
        if (typeof item.id === "string") {
          item.id = 0;
        }
        item?.subwhys?.forEach((item1, index) => {
          if (typeof item1.id === "string") {
            item1.id = 0;
          }
        });
      });

      const validateUploadFiles = checkUploadFilesValid(
        selectedFiles,
        ALLOWED_MIME_TYPES
      );

      if (validateUploadFiles.length) {
        const alertMsg = validateUploadFiles.map(
          (file) => `${file.name} - ${file.reason}`
        );
        alert(alertMsg.join("<br/>"), "Alert");
        return false;
      }

      let result = null;
      let newTableData = GridData;
      if (newTableData.length == 0) {
        alert("Please enter atleast one Gap into table", "Alert");
      } else if (
        Comments == null ||
        Comments == undefined ||
        Comments.length == 0
      ) {
        alert("Please enter Gap Analysis Comments", "Alert");
      } else {
        result = confirm(
          "Note : The gap added in the table can no longer be deleted",
          "Are you sure you want proceed?"
        );
        result.then((res) => {
          if (res) {
            dataGridRef.current?.instance?.saveEditData();
            let gapAnalysisStateWB = utils.get("wbData_isa3")
              ? JSON.stringify(utils.get("wbData_isa3"))
              : { objects: [] };

            if (newTableData.length == 0) {
              alert("Please enter atleast one Gap into table", "Alert");
            } else {
              newTableData.forEach((obj, index) => {
                if ("__KEY__" in obj) {
                  newTableData[index] = {
                    id: 0,
                    a3id: props.a3ID,
                    gapNumber : obj.gapNumber,
                    gapDescription: obj.gapDescription,
                  };
                }
              });

              let data = {
                a3id: props.a3ID,
                lastSaved: "4",

                comments: {
                  commentName: "Gap Analysis Comments",
                  comments: Comments,
                },
                whiteBoard: gapAnalysisStateWB,
                gapAnalysisData: newTableData,
                fishboneModel: fishBoneData,
                fishboneDescription: fishBoneDes,
                why: topLevelWhys.map((obj) => {
                  const filteredSubwhys = obj?.subwhys?.filter(
                    (item) => item["whyValue"] !== ""
                  );
                  return { ...obj, subwhys: filteredSubwhys };
                }),
                whyProblemStatement: whyDescription,
                lastSavedTab: "4",
                //   section: navigationOn,
                tierId: props.TierId,
                siteId: props.SiteId,
                section: props.activeTab
              };
              AsyncCallHandler(
                NEXUS_CONST.MANAGE_GAP_ANALYSIS_DATA,
                NEXUS_CONST.POST,
                data
              ).then((res) => {
                notify("Gap Analysis was successfully!", "success", 500);

                //save attachments
                if (selectedFiles?.length > 0) {
                  let formData = new FormData();

                  if (
                    selectedFiles &&
                    selectedFiles.length &&
                    Array.isArray(selectedFiles)
                  ) {
                    selectedFiles.forEach((file) => {
                      formData.append("files", file);
                    });
                  }
                  formData.append("A3Id", props.a3ID);
                  formData.append("TierID", props.TierId);
                  formData.append("attachmentType", "GapAnalysis");
                  formData.append("activeTab", props.activeTab);
                  AsyncCallHandler(
                    NEXUS_CONST.MANAGE_ATTACHMENT_A3,
                    NEXUS_CONST.PUT,
                    formData
                  ).then((res) => {
                    actions.GetAttachmentsDataA3(
                      dispatch,
                      props.a3ID,
                      "GapAnalysis"
                    );
                    setSelectedFiles([]);
                  });
                }
                AsyncCallHandler(
                  NEXUS_CONST.FETCH_A3_GAP_ANALYSIS_DATA + props.a3ID,
                  NEXUS_CONST.GET
                ).then((res) => {
                  AsyncCallHandler(
                    `${NEXUS_CONST.FETCH_A3_FISHBONE}${props.a3ID}`,
                    NEXUS_CONST.GET
                  ).then((res) => {
                    if (res) {
                      setFishBoneData(res?.data?.fishbone);
                    }
                  });
                  AsyncCallHandler(
                    `${NEXUS_CONST.FETCH_A3_FIVEWHY}${props.a3ID}`,
                    NEXUS_CONST.GET
                  ).then((res) => {
                    if (res) {
                      setTopLevelWhys(res?.data);
                    }
                  });
                  setGridData(res?.data?.gapAnalysisData);
                  setComments(res?.data?.comments.comments);
                  props.handleA3Save();
                  props.setisOpen("4");
                  props.isDataSaved(5);
                  utils.set(
                    "wbData_isa3",
                    res?.data?.whiteBoard
                      ? JSON.parse(res?.data?.whiteBoard)
                      : { objects: [] }
                  );
                });
              });
            }
          }
        });
      }
    }
  };

  const accordionData = [
    {
      title: "5 Why",
      content: (
        <div>
          <WhyAnalyzer
            topLevelWhys={topLevelWhys}
            setTopLevelWhys={setTopLevelWhys}
            whyDescription={whyDescription}
            setwhyDescription={setwhyDescription}
          />
        </div>
      ),
    },
    {
      title: "Fishbone",
      content: (
        <div>
          <Fishbone
            theRpsId={props.a3ID}
            fishBoneData={fishBoneData}
            setFishBoneData={setFishBoneData}
            fishBoneDes={fishBoneDes}
            setfishBoneDes={setfishBoneDes}
          />
        </div>
      ),
    },
    // {
    //   title: "White Board",
    //   content: (
    //     <div>
    //       <WhiteBoard
    //         siteId={props.SiteId}
    //         isRps={true}
    //         wbRef={wBRc}
    //         rpsData={utils.get("wbData_isa3")}
    //         widgetId={"isa3"}
    //       />
    //     </div>
    //   ),
    // },
  ];

  const onItemClick = (e) => {
    const clickedElement = e.event.target;
    const clickedIndex = e.itemIndex;
    let rootCauseWB = utils.get("wbData_rc")
      ? JSON.stringify(utils.get("wbData_rc"))
      : { objects: [] };

    setwhiteBrdData(
      utils.get("wbData_rc")
        ? JSON.stringify(utils.get("wbData_rc"))
        : { objects: [] }
    );
    const clsLst = [
      "dx-accordion-item-title",
      "dx-accordion-item-title-caption",
    ];
    // Check if the clicked element has a class or property that identifies it as the title element.
    const isTitleClicked =
      clickedElement.classList.contains("dx-accordion-item-title") ||
      clickedElement.classList.contains("dx-accordion-item-title-caption");

    if (isTitleClicked) {
      if (clickedIndex === 1) {
        setWBRc(!WBRc);
      }
      // Check if the clicked section is already open
      if (selectedIndexes === clickedIndex) {
        // If the clicked section is already open, do nothing

        setSelectedIndexes(0);
      } else {
        // If the clicked section is closed, open it and close others
        setSelectedIndexes(clickedIndex);

        if (clickedIndex === 0) {
          postUserLog({
            event: `Box 4 - Root Cause Analysis`,
            data: {
              action: `5 Why selected for A3-${props.a3ID}`,
              module: "Digital Tier",
              section: props.activeTab,
              siteUId: props.SiteId,
              widget: "Strategic A3",
              tierId: props.TierId,
            },
          });
        }
        if (clickedIndex === 1) {
          postUserLog({
            event: `Box 4 - Root Cause Analysis`,
            data: {
              action: `Fishbone selected for A3-${props.a3ID}`,
              module: "Digital Tier",
              section: props.activeTab,
              siteUId: props.SiteId,
              widget: "Strategic A3",
              tierId: props.TierId,
            },
          });
        }
      
       // If white board is selected log the info to userLogs -> white board accordion index is 3
        if (clickedIndex === 2) {
          postUserLog({
            event: `Box 4 - Root Cause Analysis`,
            data: {
              action: `Whiteboard selected for A3-${props.a3ID}`,
              module: "Digital Tier",
              section: props.activeTab,
              siteUId: props.SiteId,
              widget: "Strategic A3",
              tierId: props.TierId,
            },
          });
        }
      }
    }
  };

  return (
    <>
      <div className="title-section ">
        {" "}
        <h2 className="sps_title">Gap Analysis</h2>{" "}
        <div className="sps-save-btn save-btn">
          <Button
            style={{ float: "right", width: "140px", "margin-top": "3%" }}
            disabled={isDisabled}
            width={200}
            onClick={saveGapAnalysisData}
            text="Save"
            type="normal"
          />
        </div>
      </div>
      <ScrollView width="100%" height="434px" className="sps-box-s">
        <Accordion
          width="98.5%"
          multiple={false}
          animationDuration={300}
          onItemClick={onItemClick}
          collapsible={true}
          selectedIndex={selectedIndexes}
        >
          {accordionData.map((item, index) => (
            <AccordionItem
              key={index}
              title={item.title}
              // expanded={index === openItemIndex}
              // onTitleClick={(e) => handleAccordionItemClick(index)}
            >
              {item.content}
            </AccordionItem>
          ))}
        </Accordion>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div className="datagrid-machine rca">
            {GridData && (
              <DataGrid
                style={{ paddingTop: "10px", paddingRight: "20px" }}
                ref={dataGridRef}
                dataSource={GridData}
                allowColumnReordering={true}
                showBorders={true}
                onExporting={() =>
                  postUserLog({
                    event: `Box 4 - Gap Analysis Export`,
                    data: {
                      action: `Gap Analysis exported for A3-${props.a3ID}`,
                      module: "Digital Tier",
                      section: props.activeTab,
                      siteUId: props.SiteId,
                      widget: "Strategic A3",
                      tierId: props.TierId,
                    },
                  })
                }
                rowAlternationEnabled={true}
                onInitNewRow={onInitNewRow}
                {...initialstateConfig}
                {...handlers}
                wordWrapEnabled={true}
                width={"100%"}
              >
                <SearchPanel visible={true} />
                <Editing
                  mode="cell"
                  allowDeleting={false}
                  allowAdding={true}
                  allowUpdating={true}
                  useIcons={true}
                />
                <HeaderFilter visible={true} />
                <Paging defaultPageSize={5} />
                <Pager
                  visible={true}
                  allowedPageSizes={[5, 10, 20, 50]}
                  showPageSizeSelector={true}
                  showInfo={true}
                  showNavigationButtons={true}
                />
                <Column
                  dataField="id"
                  caption="Gap #"
                  allowFiltering={false}
                  allowEditing={false}
                  visible={false}
                  width={5}
                ></Column>
                <Column
                  dataField="gapNumber"
                  caption="Gap Number"
                  allowFiltering={false}
                  allowEditing={false}
                  minWidth={20}
                />
                <Column
                  dataField="gapDescription"
                  caption="Gap (s) (Description)"
                  allowFiltering={false}
                  cssClass="WrappedColumn"
                  width={900}
                  minWidth={20}
                >
                  <RequiredRule />
                </Column>
              </DataGrid>
            )}
          </div>
        </div>
        <div
          style={{
            width: "45%",
            display: "inline-block",
            position: "relative",
          }}
        >
          {" "}
          <TextArea
            label="Gap Analysis Comments *"
            labelMode="floating"
            value={Comments}
            onValueChanged={handlTextBox}
            wordWrapEnabled={true}
            className="dx-field-text"
            maxLength={500}
          ></TextArea>
        </div>
        <div>
          <div style={{ display: "flex" }}>
            <div style={{ width: "43%" }} className="no-print">
              <div className="dx-field no-print">
                <div className="dx-field-label">Gap Analysis Attachment</div>
                <FileUploader
                  className="dx-field-value gridavailable"
                  selectButtonText="Choose file"
                  labelText="Max. File Size 4 MB"
                  accept="*"
                  uploadMode="uploadUrl"
                  multiple={true}
                  onValueChanged={onFileSelect}
                  value={selectedFiles}
                  allowedFileExtensions={ALLOWED_FILE_EXTENSIONS}
                />
              </div>
              {attachmentsA3 &&
                attachmentsA3.map((item) => (
                  <div>
                    <a
                      style={{ cursor: "pointer" }}
                      className="clickable-hover"
                      onClick={() =>
                        onDownloadFile(
                          item?.attachmentName,
                          "StratagicA3",
                          "GapAnalysis"
                        )
                      }
                    >
                      {" "}
                      {item?.attachmentName}{" "}
                    </a>
                    <span className="rca_download">
                      <i
                        title="Download"
                        className="fa fa-download pointer"
                        // onClick={() =>
                        //   onDownloadFile(
                        //     item?.attachmentName,
                        //     "RPS",
                        //     "Breakdown"
                        //   )
                        // }
                      ></i>
                    </span>
                    <span
                      className="rca_delete"
                      style={{ padding: "0px 15px 0px 10px" }}
                    >
                      <i
                        title="Delete"
                        className="fas fa-trash pointer"
                        onClick={() => deleteFile(item.id,item.attachmentName)}
                      ></i>
                    </span>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </ScrollView>
    </>
  );
};
export default GapAnalysis;
